<template>
  <div class="couponProList sub-main">
    <div class='banxin'>
<!--      <img class="banner" src="../../../static/image/dpbanner@2x.png" alt="">-->
      <div class="bannerBox"></div>
      <div class="content">
        <div>
          <div v-if="noData" class="noproduct">
            <img src="../../../static/image/noorder@2x.png" alt="">
            <p class="fs20 font-color-999">该优惠券没有可用商品～</p>
          </div>
          <div>
            <h3>优惠券可用商品列表</h3>
            <ProductList :productList='productList'></ProductList>
          </div>
        </div>
        <el-pagination v-if="productList.length>0" :current-page="page" :page-size="15" @current-change="handleCurrentChange" background layout='prev, pager, next' :total='total'>
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import api from '../../api'
import {listSearchMixin} from '../../config/mixin'
import ProductList from '../../components/base/productList'
export default {
  mixins: [listSearchMixin],
  components: {
    ProductList
  },
  data () {
    return {
      page: 1,
      total: 0,
      productList: [],
      noData: false
    }
  },
  mounted () {
    this.getCouponProList()
  },
  methods: {
    // 获取分类商品
    getCouponProList () {
      const rLoading = this.openLoading()
      let self = this
      let activityId = self.$route.query.activityId
      let params = {
        url: api.getCouponProducts,
        method: 'GET',
        payload: {
          activityId,
          shopCouponId: self.$route.query.shopCouponId ? self.$route.query.shopCouponId : '',
          page: self.page,
          pageSize: 12
        }
      }
      self.sendReq(params, (res) => {
        if (res.code === '200') {
          // console.log(res)
          self.productList = res.data.list
          rLoading.close()
          if (self.productList.length === 0) {
            self.noData = true
          }
          self.total = res.data.total
        } else {
          self.$message({
            message: res.message,
            type: 'error'
          })
        }
      })
    },
    // 分页器跳转
    handleCurrentChange (val) {
      this.page = val
      this.getCouponProList()
    }
  }
}
</script>
<style lang = "scss" scoped>
.couponProList{
  width: 100%;
  height: 100%;
  background-color: #f0f0f0;
  padding-bottom: 143px;
  text-align: center;
  .banxin {
    width: 1252px;
    height: 100%;
    margin: 50px auto 0 auto;
    .head {
      width: 100%;
      height: 64px;
      line-height: 64px;
      font-size: 16px;
      display: flex;
      align-items: center;
      .all {
        margin-right: 20px;
      }
      .keyword {
        margin: 0 20px;
        color: #ff7800;
      }
      .arrow {
        background-image: url('../../../static/image/xiangyou@2x.png');
        width: 5px;
        height: 10px;
      }
    }
    .banner{
      width: 100%;
      height: 356px;
      margin-bottom: 25px;
    }
    .bannerBox {
      width: 100%;
      height: 10px;
      margin-bottom: 20px;
    }
    .content{
      background-color: #FFFFFF;
      width: 100%;
      padding: 0 45px 30px;
      box-sizing: border-box;
      h3{
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 50px;
        padding-top: 50px;
      }
      .noproduct{
        width: 100%;
        text-align: center;
        padding: 200px 0;
      }
      >>>.el-pagination{
        text-align: right;
        .el-pager{
          li:not(.disabled):hover{
            color: #FF7800;
          }
          li:not(.disabled).active{
            background-color: #FF7800;
          }
          li:not(.disabled).active:hover{
            color: #F4F4F5;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/couponProlist/index.vue